import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "LaunchStudy2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M17.25 6C17.6642 6 18 5.66421 18 5.25C18 4.83579 17.6642 4.5 17.25 4.5C16.8358 4.5 16.5 4.83579 16.5 5.25C16.5 5.66421 16.8358 6 17.25 6ZM19.5 1.5H4.5C3.67157 1.5 3 2.17157 3 3V7.5C3 8.32843 3.67157 9 4.5 9H19.5C20.3284 9 21 8.32843 21 7.5V3C21 2.17157 20.3284 1.5 19.5 1.5ZM19.5 3V7.5H4.5V3H19.5ZM12.75 13.3725L15.4425 16.0575L16.5 15L12 10.5L7.5 15L8.5575 16.0575L11.25 13.3725V22.5H12.75V13.3725ZM6 4.5H15V6H6V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/LaunchStudy2.vue"]]);
